var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJunie = function SvgJunie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#48E054",
    d: "M48 16.013v2.667C48 37.346 39.997 48 18.668 48H16V32h2.668c9.33 0 13.339-3.993 13.339-13.333L32 16.013zM16 32H0V16l16 .013zM32 16.013H16V0h16z"
  })));
};
export default SvgJunie;